<template>
  <div class="c-bookmark-thumbnail">
    <div class="c-bookmark-thumbnail__image-wrapper">
      <router-link
      :to="{ params: { page: page }}"
      class="c-bookmark-thumbnail__link"
      @click.native="closeModal()"
      :aria-label="`${$t('GO_TO')} ${$t('PAGE')} ${page}`">
        <img
          :alt="`${$t('PAGE')} ${page}`"
          :src="src"
          class="c-bookmark-thumbnail__image"/>
      </router-link>
    </div>
    <router-link
      :to="{ params: { page: page }}"
      class="c-bookmark-thumbnail__link"
      @click.native="closeModal()">
        <span class="c-bookmark-thumbnail__page">{{ page }}</span>
      </router-link>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BookmarkThumbnail',

  props: {
    book: String,
    page: Number,
    src: String
  },

  methods: {
    ...mapActions({
      closeModal: 'bookMenu/closeModal'
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-bookmark-thumbnail {
  text-align: center;
}

.c-bookmark-thumbnail__link {
  display: block;
  height: auto;

  @include a11yOutline();
}

.c-bookmark-thumbnail__image {
  max-height: 260px;
}

.c-bookmark-thumbnail__image-wrapper {
  display: inline-block;
}

.c-bookmark-thumbnail__page {
  width: 100%;
  text-align: center;
  font-size: 1rem;
  font-weight: 500;
  color: $blue;
  margin-top: 10px;
}
</style>
